import { render, staticRenderFns } from "./PostFeedTrash.vue?vue&type=template&id=ef8a0088&"
import script from "./PostFeedTrash.vue?vue&type=script&lang=js&"
export * from "./PostFeedTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports